export const AppPath = {
  Login: "/",
  ForgotPassword: "/forgot-password",
  ServiceProvider: "/service-provider",
  UserSP: "/user-service-provider",
  TenantManagement: "/tenant-management",
  UserManagement: "/user-management",
  Location: "/location",
  LocationUser: "/location-user",
  CameraManagement: "/camera-management",
  CameraInfo: "/camera-management/:id",
};

export const UserType = {
  Location: "locationUser",
  Tenant: "tenantUser",
  ServiceProvider: "spUser",
  NTTsp: "NTTSpUser",
};

export const UserRole = {
  NTTUser: "NTTUser",
  SPUser: "SPUser",
  Admin: "Admin",
  User: "User",
};

export const FilterType = {
  Tenant: "tenantID",
  Role: "role",
  SPType: "spType",
  GroupName: "groupName",
  ServiceProvider: "spID",
  SpName: "descName",
  TenantBelong: "tenantID",
  TenantName: "descName",
  Location: "locationID",
  LocationName: "descName",
  Mfa: "mfa",
  CreatedDate: "createdDate",
  UserID: "username",
  Username: "profileName",
  Type: "type",
  // Location: "location",
  Email: "email",
  CameraID: "id",
  CameraName: "name",
  ParentID: "parentID",
  Tag: "tag",
  AIOptions: "aiOptions",
  AnalysisMode: "analysisMode",
  Status: "status",
};

export const TenantIdFormat = "AAET";
export const LocationIdFormat = "AALC";
export const SPIdFormat = "AASP";
export const SPOperatorID = "AASP0001";
export const SPSaleID = "AASP0002";

export const SPType = {
  NTT: { key: "NTT", text: "System Admin" },
  "NTT-SALE": { key: "NTT-SALE", text: "NTT-sales" },
  OEM: { key: "OEM", text: "OEM事業者" },
  "RE-OEM-MAN": { key: "RE-OEM-MAN", text: "再OEM管理者" },
  "RE-OEM-OP": { key: "RE-OEM-OP", text: "再OEM事業者" },
};

export const SP_USER_NTT_TAG  = [
  "サービス主管",
  "OPS",
  "セキュリティ",
  "開通",
  "保守",
  "サポセン",
  "その他１",
  "その他２",
  "その他３"
];

export const GroupType = {
  Location: "Location",
  Tenant: "Tenant",
  ServiceProvider: "SP",
  Camera: "SP",
};

export const TextTrans = {
  Admin: "管理者",
  User: "一般",
  "Location Admin": "管理者",
  "Location User": "ユーザー",
  "NTT Operator": "NTT事業者",
  "NTT Sale": "NTT営業",
  "OEM Operator": "OEM事業者",
  "RE-OEM Operator": "RE-OEM事業者",

  "Password not long enough": "パスワードは10桁以上で指定してください",
  "Password must have lowercase characters":
    "パスワードは小文字を含めてください",
  "Password must have uppercase characters":
    "パスワードは大文字を含めてください",
  "Password must have symbol characters": "パスワードは記号を含めてください",
  "Password must have numeric characters": "パスワードは数字を含めてください",

  "Attempt limit exceeded, please try after some time.":
    "試行制限を超えました。しばらくしてからお試しください。",
  activated: "有効",
  inactivated: "無効",
  "RE-OEM": "再OEM",
  "A group with the name already exists.": "入力されたIDはすでに使われています",

  // API error codes (utils/apiClient) whose message is not Japanese
  UNAUTHORIZED: "セッションの有効期限が切れました。再度ログインしてください",
  FORBIDDEN: "この操作を行う権限がありません",
  MFA_SETUP_REQUIRED:
    "ワンタイムパスワードの設定が必要です。再度ログインしてください",
  NOT_FOUND: "対象のデータが見つかりません",
  VALIDATION_ERROR: "入力内容に誤りがあります",
  INTERNAL: "サーバーでエラーが発生しました",
  GROUP_EXISTS: "入力されたIDはすでに使われています",
  "Cannot delete default group": "デフォルトのグループは削除できません",
};

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ANALYSIS_MODE = {
  _24H: {
    label: "スタンダード",
  },
  _12H_DAY: {
    label: "ライト（昼）",
  },
  _12H_NIGHT: {
    label: "ライト（夜）",
  },
};

// A camera's aiOptions: the keys switched on, [] = every option off, null = no
// restriction (cameras not on _24H). Same keys as the API (AiOption) and the VMS.
export const AI_OPTIONS = {
  security: { label: "セキュリティ" },
  marketing: { label: "マーケット" },
};

export const aiOptionsLabel = (aiOptions) => {
  if (!aiOptions) return "";
  if (aiOptions.length === 0) return "オプション無し";
  return aiOptions.map((key) => AI_OPTIONS[key]?.label ?? key).join("・");
};

export const CAMERA_TYPE = {
  RTSP: "RTSP",
  HLS: "HLS",
};

export const STATUS = {
  activated: "activated",
  inactivated: "inactivated",
};

export const SORT_BY = {
  asc: "asc",
  dsc: "desc",
};

export const DEFAULT_LIST_FUNCTIONS = Object.entries(AI_OPTIONS).map(
  ([type, { label }], index) => ({ id: index + 1, type, title: label, checked: false })
);

export const STATUS_CAMERA = {
  initial: {
    key: "initial",
    label: "未起動",
    color: "",
  },
  added_vms: {
    key: "added_vms",
    label: "情報未入力",
    color: "orange",
  },
  activated: {
    key: "activated",
    label: "起動中",
    color: "green",
  },
};

export const REGEX_SP_ID = /^[A-Za-z]{3}\d{12}$/;
export const REGEX_LOCATION_ID = /^[A-Za-z]{3}\d{10}$/;
export const REGEX_CAMERA_ID = /^\d{10}$/;

export const TypeNotification = {
  NTT: 'NTT',
  OEM: 'OEM',
}

export const ACTIONS = {
  ADD: 'Add to VMS',
  DELETE: 'Delete from VMS'
}

export const NOTIFICATION_LIMIT = 30;